import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import { ButtonWithRequest } from '../../Zemplin/Product/ButtonWithRequest';
import { TableTd } from '../../Zemplin/General/Table';
import { Button } from '../../Zemplin/General/Button';
import { IconImg } from '../../Defaults/Icon/IconImg';
import {
  FlexRow,
  FlexColCenter,
  FlexRowCenter,
  FlexCol,
  FlexRowCenterVertical,
  FlexColCenterHorizontal,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { CountSetter } from '../Cart/CountSetter';

interface Props {
  unit: string;
  addToCart: any;
  addToRequest: any;
  handleCountChange: any;
  count: number;
}

function ProductPriceCartMobile({
  unit,
  addToCart,
  addToRequest,
  handleCountChange,
  count,
}: Props) {
  return (
    <CartWrapper>
      <CountSetter
        onChange={handleCountChange}
        unit={''}
        count={count}
        step={1}
        marginToUnits={0}
        countMarginRight={'0px'}
      />
      <ButtonWithRequest
        onButtonClick={addToCart}
        onRequestClick={addToRequest}
        noStock={false}
      />
    </CartWrapper>
  );
}

const CartWrapper = styled(FlexRow)``;

export { ProductPriceCartMobile };
